import React from "react";
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  FormHelperText 
} from "@mui/material";

interface CategorySelectProps {
  value: string;
  categories: { _id: { $oid: string }; CategoryName: string }[];
  onChange: (value: string) => void;
}

const CategorySelect: React.FC<CategorySelectProps> = ({ value, categories, onChange }) => {
  const isError = !value;

  return (
    <FormControl 
      fullWidth 
      variant="outlined"
      error={isError}
      sx={{ 
        mt: 0,
        '& .MuiFormLabel-asterisk': {
          color: 'error.main'
        }
      }}
    >
      <InputLabel 
        id="category-select-label"
        sx={{ 
          color: isError ? 'error.main' : 'text.primary',
          '&.Mui-focused': {
            color: isError ? 'error.main' : 'primary.main'
          }
        }}
      >
        Category type *
      </InputLabel>
      <Select
        labelId="category-select-label"
        id="categoryId"
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        label="Category type *"
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              maxHeight: 300
            }
          }
        }}
      >
        <MenuItem value="" disabled>
          Select category *
        </MenuItem>
        {categories.map((c) => (
          <MenuItem key={c._id.$oid} value={c._id.$oid}>
            {c.CategoryName}
          </MenuItem>
        ))}
      </Select>
      {isError && (
        <FormHelperText sx={{ color: 'error.main', fontSize: '0.75rem', mx: 0 }}>
          Category type is required
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CategorySelect;